import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { decrypt } from "../utils/crypto";
import { getIP } from "../utils/getIp";

import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
let ip = "";

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const userAuth =
    localStorage.getItem("token") && decrypt(localStorage.getItem("token"));
  const superAdminAuth =
    localStorage.getItem("super-admin-auth") &&
    decrypt(localStorage.getItem("super-admin-auth"));

  const token = userAuth ? userAuth : superAdminAuth;

  token?.authToken
    ? operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          authorization: `Bearer ${token?.authToken}`,
          "Client-IP": ip,
        },
      }))
    : operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          "Client-IP": ip,
        },
      }));

  return forward(operation);
});

const logoutLink = onError(({ networkError, response, graphQLErrors }) => {
  const newgraphQLErrors =
    graphQLErrors?.length &&
    graphQLErrors?.map((error) => ({
      error: error?.message,
      statusCode: error?.extensions?.http?.status,
    }));
  console.log("=====API ERROR=====", newgraphQLErrors, "=====API ERROR=====");
  if (newgraphQLErrors?.length && newgraphQLErrors[0]?.statusCode === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("super-admin-auth");
    window.location.pathname = "/login";
  } else if (
    newgraphQLErrors?.length &&
    newgraphQLErrors[0]?.statusCode === 403
  ) {
    window.location.href = "/no-access";
  }
  return false;
});

getIP()
  .then((res) => (ip = res))
  .catch((error) => {
    return "";
  });

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([
    logoutLink,
    authMiddleware,
    createUploadLink({ uri: `${process.env.REACT_APP_BASE_URL}graphql` }),
  ]),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache", // Set the default fetch policy for queries
    },
  },
});
